/* eslint-disable react/prop-types */
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Button, darken } from "@mui/material";
import { Stack } from "@mui/system";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import XLSX from "xlsx-js-style";

/* eslint-disable react/prop-types */
function TableTotalProduct({
  columns,
  data,
  count,
  pagination,
  setPagination,
  isLoading,
  isError,
  isRefetching,
  tableKeyValues,
  filename,
  titleTable,
  widthPercentPDF,
  orientaitionPage,
  subRow,
  allData,
  isUsingAllData,
  dicSizeBreakWord,
  ...props
}) {
  const handleExportDataExcel = (tableData) => (e) => {
    const dataSheet = tableData;
    if (dataSheet?.length > 0) {
      const heading = [
        [
          "TT",
          "Địa phương/Tên sản phẩm",
          "Nhóm ngành hàng ",
          "Tên chủ thể sản xuất/kinh doanh",
          "Trạng thái",
          "Kí hiệu",
          "Địa chỉ",
          //   "Tên giám đốc DN, HTX, THT, chủ hộ",
          "Giới tính",
          "Chủ thể là DTTS",
          "Điện thoại liên hệ",
          "Hạng sao OCOP",
        ],
      ];
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(ws, [[titleTable]], { origin: "A1" });
      XLSX.utils.sheet_add_aoa(ws, heading, { origin: "A2" });
      XLSX.utils.sheet_add_aoa(ws, [["5", "4", "3", "2", "1"]], {
        origin: "K3",
      });
      XLSX.utils.sheet_add_aoa(ws, [["Tổng cộng", "Năm công nhận"]], {
        origin: "P2",
      });
      XLSX.utils.sheet_add_json(ws, dataSheet, {
        skipHeader: true,
        origin: "A4",
      });
      // Hợp nhất các ô từ A2 và A3, B2 và B3, ... đến I2 và I3
      let merges = [];
      for (let c = 0; c < 10; c++) {
        // Từ A (cột 1) đến J (cột 9)
        merges.push({ s: { r: 1, c: c }, e: { r: 2, c: c } });
      }
      for (let c = 15; c < 17; c++) {
        // Từ P (cột 14) đến Q (cột 15)
        merges.push({ s: { r: 1, c: c }, e: { r: 2, c: c } });
      }
      // Hợp nhất các ô từ K2 đến O2
      merges.push({ s: { r: 1, c: 10 }, e: { r: 1, c: 14 } });
      merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: 16 } });

      ws["!merges"] = merges;
      const rangeCellHeading = XLSX.utils.decode_range("A1:Q1");
      for (
        let rowNum = rangeCellHeading.s.r;
        rowNum <= rangeCellHeading.e.r;
        rowNum++
      ) {
        for (
          let colNum = rangeCellHeading.s.c;
          colNum <= rangeCellHeading.e.c;
          colNum++
        ) {
          const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
          const cell = ws[cellAddress] || {};

          // Apply center
          const style = cell.s || {};
          // style.border = {
          //   top: { style: "thin", color: { rgb: "121212" } },
          //   bottom: { style: "thin", color: { rgb: "121212" } },
          //   left: { style: "thin", color: { rgb: "121212" } },
          //   right: { style: "thin", color: { rgb: "121212" } },
          // };
          style.alignment = {
            horizontal: "center",
            vertical: "center",
            wrapText: true,
          }; // Center
          style.font = {
            bold: true,
            sz: 15,
            name: "Times New Roman",
          };
          cell.s = style;
          ws[cellAddress] = cell;
        }
      }
      // Đặt style cho từng ô trong phạm vi từ A2 đến Q3
      const rangeCells = XLSX.utils.decode_range("A2:Q3");
      for (let rowNum = rangeCells.s.r; rowNum <= rangeCells.e.r; rowNum++) {
        for (let colNum = rangeCells.s.c; colNum <= rangeCells.e.c; colNum++) {
          const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
          const cell = ws[cellAddress] || {};

          // Apply center
          const style = cell.s || {};
          // style.border = {
          //   top: { style: "thin", color: { rgb: "121212" } },
          //   bottom: { style: "thin", color: { rgb: "121212" } },
          //   left: { style: "thin", color: { rgb: "121212" } },
          //   right: { style: "thin", color: { rgb: "121212" } },
          // };
          style.alignment = {
            horizontal: "center",
            vertical: "center",
            wrapText: true,
          }; // Center
          style.font = {
            bold: true,
            sz: 12,
            name: "Times New Roman",
          };
          cell.s = style;
          ws[cellAddress] = cell;
        }
      }
      // Set the height for row 1
      ws["!rows"] = ws["!rows"] || [];
      ws["!rows"][0] = { hpx: 40 };
      //Thiết lập width mỗi cột
      const colWidths = [
        5, 28, 15, 25, 20, 10, 25, 20, 12, 15, 5, 5, 5, 5, 5, 10, 12,
      ];
      const newcolWidths = [];
      colWidths?.forEach((item) => newcolWidths.push({ wch: item }));
      ws["!cols"] = newcolWidths;

      // Thiết lập wrapText cho tất cả các ô từ A4
      const rangeAll = XLSX.utils.decode_range(ws["!ref"]);
      for (let rowNum = 3; rowNum <= rangeAll.e.r; rowNum++) {
        for (let colNum = rangeAll.s.c; colNum <= rangeAll.e.c; colNum++) {
          const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
          const cell = ws[cellAddress] || {};
          // Apply text wrap
          const style = cell.s || {};
          style.border = {
            top: { style: "thin", color: { rgb: "121212" } },
            bottom: { style: "thin", color: { rgb: "121212" } },
            left: { style: "thin", color: { rgb: "121212" } },
            right: { style: "thin", color: { rgb: "121212" } },
          };
          style.alignment = {
            vertical: "center",
            wrapText: true,
          };
          style.font = {
            sz: 11,
            name: "Times New Roman",
          };
          cell.s = style;
          ws[cellAddress] = cell;
        }
      }
      const startCol = 15; // Column P is index 15 (0-based index)
      const endCol = 16; // Column Q is index 16 (0-based index)
      const maxRow = XLSX.utils.decode_range(ws["!ref"]).e.r;

      // Apply green background color to columns P and Q
      for (let rowNum = 0; rowNum <= maxRow; rowNum++) {
        for (let colNum = startCol; colNum <= endCol; colNum++) {
          const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
          const cell = ws[cellAddress] || {};

          // Apply green background color
          const style = cell.s || {};
          style.fill = {
            fgColor: { rgb: "92D050" }, // Green color
            patternType: "solid", // Solid fill
          };
          cell.s = style;

          // Update the cell in the sheet
          ws[cellAddress] = cell;
        }
      }
      XLSX.utils.book_append_sheet(wb, ws, filename);
      XLSX.writeFile(wb, `${filename}.xlsx`);
    }
  };

  return (
    <MaterialReactTable
      muiToolbarAlertBannerProps={
        isError
          ? {
              color: "error",
              children: "Lỗi khi lấy dữ liệu",
            }
          : undefined
      }
      enableRowNumbers
      rowNumberMode="static"
      columns={columns}
      data={data}
      enableFilters={true}
      enableHiding={false}
      enableColumnOrdering={false}
      enableDensityToggle={true}
      enableColumnResizing
      manualPagination
      onPaginationChange={setPagination}
      rowCount={count}
      localization={MRT_Localization_VI}
      initialState={{
        isLoading: true,
        columnVisibility: {
          id: false,
        },
        density: "compact",
      }}
      state={{
        pagination,
        isLoading,
        showAlertBanner: isError,
        showProgressBars: isRefetching,
      }}
      muiTablePaperProps={{
        elevation: 0,
        sx: {
          borderRadius: "0",
          border: "1px solid rgb(211 225 245)",
          backgroundColor: "#fff",
        },
      }}
      muiTableBodyProps={{
        sx: (theme) => ({
          "& tr:nth-of-type(odd)": {
            backgroundColor: darken(theme.palette.background.default, 0.1),
          },
        }),
      }}
      renderTopToolbarCustomActions={({ table }) => {
        let tableData = table
          ?.getPrePaginationRowModel()
          .rows.map((row, index) => {
            let defaultValue = row.original;
            let text = {};
            tableKeyValues?.forEach((key) => {
              text[key] = defaultValue[key];
            });
            return text;
          });
        const cloneTableData = allData?.map((row) => {
          let text = {};
          tableKeyValues?.forEach((key) => {
            text[key] = row[key];
          });
          return text;
        });
        tableData = isUsingAllData ? [...cloneTableData] : [...tableData];
        return (
          <Stack spacing={2} direction="row" color="white">
            <Button
              disabled={table.getPrePaginationRowModel().rows.length === 0}
              onClick={handleExportDataExcel(tableData)}
              startIcon={<FileDownloadIcon />}
            >
              Excel
            </Button>
            {/* {renderButtonDownload} */}
          </Stack>
        );
      }}
      {...props}
    />
  );
}

export default TableTotalProduct;
